//@ts-nocheck
import "./style.css";
import Atom from "../atom";
import MapJson from "./SWJson.json";
import Storage from "../../lib/storage/storage";
import { Trn } from "../../translations/language";
import React, { useEffect, useState } from "react";
import { useOpener } from "../../hooks/opener/useOpener";
import ServiceWorker from "../../lib/sw/sw";

type propsType = {
  title?: any;
  message?: any;
};

export default function SwController(props: propsType) {
  const { title, message } = props;

  const { isOpen, onClose, onOpen } = useOpener();
  const {
    isOpen: isOpenGuid,
    onClose: onCloseGuid,
    onOpen: onOpenGuid,
  } = useOpener();

  const [content, setContent] = useState(
    message || Trn({ text: MapJson["pushMessage"]?.message })
  );
  const [, setPermissionState] = useState();

  useEffect(() => {
    const state = ServiceWorker.getPushState();
    switch (state) {
      //اجازه دسترسی وجود دارد
      case 200:
        ServiceWorker.pushPermissionReq({ onAccept: onAccept(200), onReject });
        break;
      case 2:
        onOpenModal();
        break;
      case 3:
        onOpenModal();
        break;
      case 4:
        onOpenGuid();
        ServiceWorker.pushPermissionReq({ onAccept, onReject });
        break;
      case 5:
        onOpenModal();
        setContent(
          Trn({
            text: "you_block_notification_if_you_want_to_get_help_please_click_help_button",
          })
        );
        break;
      case 6:
        setContent(
          Trn({
            text: "you_block_notification_if_you_want_to_get_help_please_click_help_button",
          })
        );
        onOpenModal();
        break;
    }
    
  }, []);

  function onAccept(state) {
    if (state !== 200) {
      onClose();
      onCloseGuid();
      savePermission(true);
    }
    Storage.setPermission({ type: "pushMessage", value: true });
    setAclConnector();
  }

  function onReject() {
    //todo:اجازه داده نشده
    savePermission(false);
    onClose();
    onCloseGuid();
    Storage.setPermission({ type: "pushMessage", value: false });
  }

  function saveHintPermission(allow) {
    Storage.setPermission({ type: "pushHintMessage", value: allow });
  }

  function savePermission(allow) {
    Storage.setPermission({ type: "pushMessage", value: allow });
  }

  function allowPermission() {
    onOpenGuid();
    saveHintPermission(true);
    setPermissionState(true);
    ServiceWorker.pushPermissionReq({ onAccept, onReject });
  }

  function denyPermission() {
    saveHintPermission(false);
    onClose();
    setPermissionState(false);
  }

  function setAclConnector() {
    /*   const permission = Storage.getPermission();
    if (permission?.endPointACLConnector) {
      ServiceWorker.setMyEndPointAsACLConnector();
    } else {
      ServiceWorker.setMyEndPointAsACLConnector();
    }*/
    ServiceWorker.setMyEndPointAsACLConnector();
  }

  function onOpenModal() {
    const permission = Storage.getPermission();
    if (_Params?.notificationRequestModal && !permission?.donShowAgain) {
      onOpen();
    }
  }

  function dontShowAgain() {
    Storage.mergeValue("permission", { donShowAgain: true });
    onClose();
  }

  return (
    <>
      <Atom.HintModal
        showAgain
        open={isOpen}
        onClose={onClose}
        onReject={denyPermission}
        onAccept={allowPermission}
        onShowAgain={dontShowAgain}
        header={title || Trn({ text: MapJson["pushMessage"]?.title })}
      >
        <Atom.Typography className="text-center">{content}</Atom.Typography>
      </Atom.HintModal>

      <Atom.GuidnessModal open={isOpenGuid}>
        {Trn({ text: "click_allow_button" })}
      </Atom.GuidnessModal>
    </>
  );
}
